export enum OPERATION_TYPE {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
}

export enum PAYMENT_CONFIG {
  SINGLE = 'SINGLE',
  MULTI = 'MULTI',
}

export enum TRANS_TYPE {
  CB= 'CB',
  TPE = 'TPE',
  ESPECE= 'ESPECE',
  CHEQUE= 'CHEQUE',
  CHEQUE_VACANCE = 'CHEQUE VACANCE',
  VIREMENT = 'VIREMENT',
  BON_CADEAU = 'BON CADEAU',
}

export enum TRANS_STATUS {
  /**
   * Abandonné : Paiement abandonné par l’acheteur.
   * La transaction n’est pas créée et n’est donc pas visible dans le Back Office.
   */
  ABANDONED = 'ABANDONED',
  /**
   * En attente de remise : La transaction est acceptée et sera remise en banque automatiquement à la date prévue.
   */
  AUTHORISED = 'AUTHORISED',
  /**
   * A valider : La transaction, créée en validation manuelle, est autorisée.
   * Le marchand doit valider manuellement la transaction afin qu'elle soit remise en banque.
   * La transaction peut être validée tant que la date d'expiration de la demande d'autorisation n’est pas dépassée.
   * Si cette date est dépassée alors le paiement prend le statut EXPIRED. Le statut Expiré est définitif.
   */
  AUTHORISED_TO_VALIDATE = 'AUTHORISED_TO_VALIDATE',
  /** Annulée : La transaction est annulée par le marchand. */
  CANCELLED = 'CANCELLED',
  /** Remisée : La transaction est remise en banque. */
  CAPTURED = 'CAPTURED',
  /** La remise de la transaction a échoué. */
  CAPTURE_FAILED = 'CAPTURE_FAILED',
  /**
   Expirée : La date d'expiration de la demande d'autorisation est atteinte et le marchand
   n’a pas validé la transaction. Le porteur ne sera donc pas débité.
  */
  EXPIRED = 'EXPIRED',
  /**
   En attente : Ce statut est spécifique à tous les moyens de paiement nécessitant
   une intégration par formulaire de paiement en redirection.
   Ce statut est retourné lorsque :
   • aucune réponse n'est renvoyée par l'acquéreur ou
   • le délai de réponse de la part de l'acquéreur est supérieur à la durée de session du paiement sur la plateforme de paiement.
   Ce statut est temporaire. Le statut définitif sera affiché dans le Back Office aussitôt la synchronisation réalisée.
  */
  INITIAL = 'INITIAL',
  /** Transaction non créée : La transaction n'est pas créée et n'est pas visible dans le Back Office. */
  NOT_CREATED = 'NOT_CREATED',
  /** Refusée : La transaction est refusée. */
  REFUSED = 'REFUSED',
  /** Vérification en cours : Spécifique à PayPal */
  UNDER_VERIFICATION = 'UNDER_VERIFICATION',
  /**
   * En attente d’autorisation : Le délai de remise en banque est
   * supérieur à la durée de validité de l'autorisation.
   */
  WAITING_AUTHORISATION = 'WAITING_AUTHORISATION',
  /**
   * A valider et autoriser : Le délai de remise en banque est supérieur à la durée de validité de l'autorisation.
   * Une autorisation 1 euro a été acceptée.
   * Le marchand doit valider manuellement la transaction afin que la demande d’autorisation et la remise aient lieu.
   */
  WAITING_AUTHORISATION_TO_VALIDATE = 'WAITING_AUTHORISATION_TO_VALIDATE',
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/transactions/transaction.constants.ts